export default __webpack_public_path__ + "static/media/vkbg1.049fd037.svg";